module.exports = __webpack_public_path__ + "img/Weapon_115.6ec07e4c.png";